import React from "react";

import TextFetcher from "../../Utils/TextFetcher.js";
import Overlay from "../Overlay";

import styles from "./SearchBar.module.scss";
import {
    handleSearchValueChange,
    handleSearchValueSubmit,
    populateAutoComplete
} from "../../Store/Actions/NewFilterActions";
import {useDispatch, useSelector} from "react-redux";
import {SET_KEYBOARD_POSITION} from "../../Store/Actions/ActionTypes";
import icon from "../../img/sok-white.svg";


const SearchBar = (props) => {
    const newFilterState = useSelector(state => state.newFilterReducer);
    const responseCache = newFilterState.responseCache;

    const dispatch = useDispatch();
    const acSearchResultRaw = newFilterState.acSearchResult;
    const acSearchResult = acSearchResultRaw ? acSearchResultRaw['hydra:member'] : [];
    const keyDown = (e) => {
        if (acSearchResult.length) {
            if (e.keyCode === 38) { // Up arrow: go to the last element
                dispatch({type: SET_KEYBOARD_POSITION, payload: acSearchResult.length - 1});
            }
            else if (e.keyCode === 40) { // Down arrow: go to the first element
                dispatch({type: SET_KEYBOARD_POSITION, payload: 0});
            }
            else if (e.keyCode === 13) { // Handle enter
                submitValue();
            }
        }
    };

    const changeValue = (e) => {
        const val = e.target.value;
        dispatch(handleSearchValueChange(val));
        if (val.trim()) {
            dispatch(populateAutoComplete({value: val, responseCache: responseCache}));
        }
    };

    const submitValue = () => {
        const searchValue = newFilterState.acSearchInputValue;
        dispatch(handleSearchValueSubmit(searchValue));
    };

    const clearValue = () => {
        dispatch(handleSearchValueChange(""));
    };

    return (
        <React.Fragment>
            <div className={styles.searchbar}>
                <div className={styles.wrapper}>
                    <input
                        id="search-input"
                        onChange={changeValue}
                        onKeyDown={keyDown}
                        className={styles.searchbar_searchinput}
                        placeholder={TextFetcher("searchPH", "nb")}
                        value={newFilterState.acSearchInputValue}
                        role="searchbox"
                        aria-label="Skriv søkeord her"
                    />
                    { newFilterState.acSearchInputValue &&
                    <div tabIndex={0} onClick={clearValue} className={styles.clearbutton}>×</div>
                    }
                </div>
                <button onClick={submitValue} className={styles.icon}>
                    <img alt="Søkeikon" src={icon} aria-hidden="true" />
                    <span>{TextFetcher("search", "nb")}</span>
                </button>
            </div>
            {newFilterState.acOverlay &&
                <Overlay />
            }
        </React.Fragment>
    )
}

export default SearchBar;
